/**
 * Wrapper para o fluxo de autenticação:
 *   login → (se OTP ativo) → otp → /
 *   /login/password-reset?token=...&email=... → reset
 * Não exige usuário autenticado.
 */
import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import LoginPage from './pages/LoginPage';
import OtpPage from './pages/OtpPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

type Phase = 'login' | 'otp' | 'reset';
type OtpData = { maskedEmail: string; ttlMinutes: number };

function getInitialPhase(): Phase {
    if (window.location.pathname === '/login/password-reset') return 'reset';
    return 'login';
}

function getResetParams() {
    const params = new URLSearchParams(window.location.search);
    return {
        token: params.get('token') ?? '',
        email: params.get('email') ?? '',
    };
}

export default function AuthApp() {
    const [phase, setPhase]     = useState<Phase>(getInitialPhase);
    const [otpData, setOtpData] = useState<OtpData | null>(null);
    const resetParams            = getResetParams();

    const handleNeedsOtp = (data: OtpData) => {
        setOtpData(data);
        setPhase('otp');
    };

    const handleBackToLogin = () => {
        setPhase('login');
        setOtpData(null);
    };

    return (
        <>
            {phase === 'login' && (
                <LoginPage onNeedsOtp={handleNeedsOtp} />
            )}
            {phase === 'otp' && otpData && (
                <OtpPage
                    maskedEmail={otpData.maskedEmail}
                    ttlMinutes={otpData.ttlMinutes}
                    onBack={handleBackToLogin}
                />
            )}
            {phase === 'reset' && (
                <ResetPasswordPage
                    token={resetParams.token}
                    email={resetParams.email}
                    onBack={() => { window.location.href = '/login'; }}
                />
            )}
            <Toaster position="top-right" toastOptions={{ className: 'text-sm' }} />
        </>
    );
}
